export * from './wall'
export * from './roof';
export * from './catalog-window';
export * from './warehouse-window';
export * from './space-config-window';
export * from './monitor-window';
export * from './management-window';
export * from './totalizer-window';
export * from './dummy-window';
export * from './library-window';
export * from './border';
export * from './roof-box';
export * from './roof-vent'
export * from './square-vent';
export * from './base';
export * from './square-box';
export * from './helipad';
export * from './shadow';

export * from './tree';
export * from './cloud';
export * from './navigation-button';
export * from './icon';

import { WallComponent } from './wall';
import { RoofComponent } from './roof';
import { BorderComponent } from './border';
import { RoofBoxComponent } from './roof-box';
import { RoofVentComponent } from './roof-vent';
import { BaseComponent } from './base';
import { SquareBoxComponent } from './square-box';
import { HelipadComponent } from './helipad';
import { CatalogWindowComponent } from './catalog-window';
import { WarehouseWindowComponent } from './warehouse-window';
import { SpaceConfigWindowComponent } from './space-config-window';
import { MonitorWindowComponent } from './monitor-window';
import { ManagementWindowComponent } from './management-window';
import { TotalizerWindowComponent } from './totalizer-window';
import { DummyWindowComponent } from './dummy-window';

import { SquareVentComponent } from './square-vent';
import { LibraryWindowComponent } from './library-window';
import { NavigationButtonComponent } from './navigation-button';
import { IconComponent } from './icon';
import { ShadowComponent } from './shadow';
import { TreeComponent } from './tree';
import { CloudComponent } from './cloud';

export const BuildingAtoms = [
    WallComponent,
    RoofComponent,
    CatalogWindowComponent,
    WarehouseWindowComponent,
    SpaceConfigWindowComponent,
    MonitorWindowComponent,
    ManagementWindowComponent,
    TotalizerWindowComponent,
    DummyWindowComponent,
    LibraryWindowComponent,
    BorderComponent,
    RoofBoxComponent,
    RoofVentComponent,
    SquareVentComponent,
    BaseComponent,
    SquareBoxComponent,
    HelipadComponent,
    NavigationButtonComponent,
    IconComponent,
    ShadowComponent,
    TreeComponent,
    CloudComponent
]